<template>
  <section>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="step-form__main">
          <el-row :gutter="0">
            <el-col :span="16">
              <el-form class="step-form__form" :model="brokerSubmitForm" ref="brokerSubmitForm" :rules="rules">
                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;">Business Information</h3>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="businessName" required>
                      <el-input type="text" placeholder="Company legal name *" v-model="brokerSubmitForm.businessName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="tradeName">
                      <el-input type="text" placeholder="DBA (If applicable)" v-model="brokerSubmitForm.tradeName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="businessStreetAddress" required>
                      <el-input type="text" placeholder="Address *" :maxlength="40" v-model="brokerSubmitForm.businessStreetAddress"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="businessStreetAddressLine2">
                      <el-input type="text" placeholder="Address Line 2" :maxlength="40" v-model="brokerSubmitForm.businessStreetAddressLine2"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="businessCityName" required>
                      <el-input type="text" placeholder="City *" :maxlength="30" v-model="brokerSubmitForm.businessCityName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="businessState"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.businessState" placeholder="Select state *">
                        <el-option label="Select state" value="" disabled></el-option>
                        <el-option
                          v-for="item in stateS"
                          :key="item.text"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="businessZip" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Zip *"
                        :maxlength="5"
                        v-model="brokerSubmitForm.businessZip"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="businessPhone" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Company phone *"
                        :maxlength="10"
                        v-model="brokerSubmitForm.businessPhone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="companyEmail" required>
                      <el-input
                        type="text"
                        placeholder="Company email *"
                        :maxlength="30"
                        v-model="brokerSubmitForm.companyEmail"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item>
                      <el-input type="text" v-model="brokerSubmitForm.url" placeholder="Website"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="stateOfInc"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.stateOfInc" placeholder="Select state of incorporation *">
                        <el-option label="Select state of incorporation" value="" disabled></el-option>
                        <el-option
                          v-for="item in stateS"
                          :key="item.text"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="yearsInBusiness" required>
                      <el-input
                        type="number"
                        v-model="brokerSubmitForm.yearsInBusiness"
                        placeholder="Years in business *"
                        :maxlength="16"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item style="width: 100%;" prop="tin" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="EIN (Tax ID number) *"
                        :maxlength="10"
                        v-model="brokerSubmitForm.tin"
                        @input="handleTinInput"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="industry"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.industry" placeholder="Select industry type *">
                        <el-option label="Select industry type" value="" disabled></el-option>
                        <el-option
                          v-for="item in industries"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="structure"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.structure" placeholder="Select company structure *">
                        <el-option label="Select company structure" value="" disabled></el-option>
                        <el-option
                          v-for="item in structures"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="revenue">
                      <el-input
                        type="number"
                        v-model="brokerSubmitForm.revenue"
                        placeholder="Annual revenue"
                        :maxlength="16"
                      >
                        <template slot="prepend">$</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Business description" class="margin-bottom-0" prop="description" required>
                  <el-input type="textarea" placeholder="Please include details by describing your business, revenue stream, and specifics to the need for this loan. For Equipment Financing, please also add how this equipment loan will increase your revenue (i.e. debt service coverage ratio before and after loan) and what is the timing you will start to see a contribution to your revenue?" v-model="brokerSubmitForm.description" :rows=3></el-input>
                </el-form-item>

                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;">Business Owners</h3>
                </el-row>
                <el-row :gutter="20">
                  <!--First Name-->
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item prop="firstName" required>
                      <el-input type="text" placeholder="First name *" :maxlength="30" v-model="brokerSubmitForm.firstName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="4" :lg="4">
                    <el-form-item>
                      <el-input type="text" placeholder="Middle name" :maxlength="30" v-model="brokerSubmitForm.middleName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item prop="lastName" required>
                      <el-input type="text" placeholder="Last name *" :maxlength="30" v-model="brokerSubmitForm.lastName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="ssn" required>
                      <el-input
                        type="text"
                        placeholder="Social security number *"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        v-model="brokerSubmitForm.ssn"
                        :maxlength="9"
                      ></el-input>
                      <!-- We use 256-bit SSL protection and strict, high levels of security
                      <br />and encryption standards to keep
                      your information safe. -->
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="streetAddress" required>
                      <el-input
                        type="text"
                        placeholder="Home address *"
                        :maxlength="40"
                        v-model="brokerSubmitForm.streetAddress"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="4" :lg="4">
                    <el-form-item prop="streetAddressLine2">
                      <el-input
                        type="text"
                        placeholder="Address Line 2"
                        :maxlength="40"
                        v-model="brokerSubmitForm.streetAddressLine2"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item prop="cityName" required>
                      <el-input type="text" placeholder="City name *" :maxlength="30" v-model="brokerSubmitForm.cityName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item prop="state" class="step-form__form-item--with-unit" required>
                      <el-select v-model="brokerSubmitForm.state" placeholder="Select state *">
                        <el-option label="Select state" value="" disabled></el-option>
                        <el-option
                          v-for="item in stateS"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="zipCode" required>
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Zip code *"
                        :maxlength="5"
                        v-model="brokerSubmitForm.zipCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="cellPhone" required>
                      <el-input
                        type="tel"
                        placeholder="Phone *"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        v-model="brokerSubmitForm.cellPhone"
                        :maxlength="10"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="email" required>
                      <el-input
                        type="text"
                        placeholder="Email *"
                        v-model="brokerSubmitForm.email"
                        :maxlength="30"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="jobTitle">
                      <el-input
                        type="text"
                        placeholder="Title (if applicable)"
                        v-model="brokerSubmitForm.jobTitle"
                        :maxlength="30"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="businessOwnership" required>
                      <el-input
                        type="number"
                        v-model="brokerSubmitForm.businessOwnership"
                        placeholder="Business ownership % *"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        :min="0"
                        :max="100"
                      >
                        <template slot="append">%</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;" v-on:click="showAddOwner = !showAddOwner">Add owner<i style="float: right; margin-right: 10px;" class="fa" :class="{'fa-chevron-up': showAddOwner, 'fa-chevron-down': !showAddOwner }" aria-hidden="true"></i></h3>
                </el-row>

                <div v-show="showAddOwner">
                  <el-row :gutter="20">
                    <!--First Name-->
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item prop="firstName2">
                        <el-input type="text" placeholder="First name" :maxlength="30" v-model="brokerSubmitForm.firstName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="4" :lg="4">
                      <el-form-item>
                        <el-input type="text" placeholder="Middle name" :maxlength="30" v-model="brokerSubmitForm.middleName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item prop="lastName2">
                        <el-input type="text" placeholder="Last name" :maxlength="30" v-model="brokerSubmitForm.lastName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="ssn2">
                        <el-input
                          type="text"
                          placeholder="Social security number"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          v-model="brokerSubmitForm.ssn2"
                          :maxlength="9"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="streetAddress2">
                        <el-input
                          type="text"
                          placeholder="Home address"
                          :maxlength="40"
                          v-model="brokerSubmitForm.streetAddress2"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="4" :lg="4">
                      <el-form-item prop="streetAddress2Line2">
                        <el-input
                          type="text"
                          placeholder="Address Line 2"
                          :maxlength="40"
                          v-model="brokerSubmitForm.streetAddress2Line2"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item prop="cityName2">
                        <el-input type="text" placeholder="City name" :maxlength="30" v-model="brokerSubmitForm.cityName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="6" :lg="6">
                      <el-form-item prop="state2" class="step-form__form-item--with-unit">
                        <el-select v-model="brokerSubmitForm.state2" placeholder="Select state">
                          <el-option label="Select state" value="" disabled></el-option>
                          <el-option
                            v-for="item in stateS"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="zipCode2">
                        <el-input
                          type="tel"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          placeholder="Zip code"
                          :maxlength="5"
                          v-model="brokerSubmitForm.zipCode2"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="cellPhone2">
                        <el-input
                          type="tel"
                          placeholder="Phone"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          v-model="brokerSubmitForm.cellPhone2"
                          :maxlength="10"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item prop="email2">
                        <el-input
                          type="text"
                          placeholder="Email"
                          v-model="brokerSubmitForm.email2"
                          :maxlength="30"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item prop="jobTitle2">
                        <el-input
                          type="text"
                          placeholder="Title (if applicable)"
                          v-model="brokerSubmitForm.jobTitle2"
                          :maxlength="30"
                        ></el-input>
                      </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item prop="businessOwnership2">
                        <el-input
                          type="number"
                          v-model="brokerSubmitForm.businessOwnership2"
                          placeholder="Business ownership %"
                          onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :min="0"
                          :max="100 - brokerSubmitForm.businessOwnership"
                        >
                          <template slot="append">%</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>

                <el-row>
                  <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;">Vendor (if applicable)</h3>
                </el-row>              
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="vendorName">
                      <el-input type="text" placeholder="Vendor name" v-model="brokerSubmitForm.vendorName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item prop="vendorPhone">
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Vendor phone"
                        :maxlength="10"
                        v-model="brokerSubmitForm.vendorPhone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item prop="vendorAddress">
                  <el-input type="text" :maxlength="40" v-model="brokerSubmitForm.vendorAddress" placeholder="Vendor address"></el-input>
                </el-form-item>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="vendorCity">
                      <el-input type="text" :maxlength="30" v-model="brokerSubmitForm.vendorCity" placeholder="City"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="vendorState"
                      class="step-form__form-item--with-unit"
                    >
                      <el-select v-model="brokerSubmitForm.vendorState" placeholder="Select state">
                        <el-option label="Select state" value="Select state" disabled></el-option>
                        <el-option
                          v-for="item in stateS"
                          :key="item.text"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="vendorZipCode">
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="Zip code"
                        :maxlength="5"
                        v-model="brokerSubmitForm.vendorZipCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="Contact first name">
                      <el-input type="text" placeholder="Contact first name" :maxlength="30" v-model="brokerSubmitForm.vendorContactFirstName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="Contact last name">
                      <el-input type="text" placeholder="Contact last name" :maxlength="30" v-model="brokerSubmitForm.vendorContactLastName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="Contact email">
                      <el-input
                        type="text"
                        placeholder="Contact email"
                        :maxlength="30"
                        v-model="brokerSubmitForm.vendorContactEmail"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item label="Equipment amount" prop="equipmentAmount" required>
                      <el-input
                        type="number"
                        v-model="brokerSubmitForm.equipmentAmount"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        :maxlength="8"
                        :min="0"
                      >
                        <template slot="prepend">$</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item
                      label="Equipment status"
                      prop="equipmentStatus"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.equipmentStatus" placeholder="Equipment Status *">
                        <el-option
                          v-for="item in status"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item
                      label="Equipment Type"
                      prop="equipmentType"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.equipmentType" placeholder="Equipment Type *">
                        <!-- <el-option label="Equipment Type" value="" disabled></el-option> -->
                        <el-option
                          v-for="item in equipmentTypes"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6">
                    <el-form-item
                      label="Reason for equipment purchase"
                      prop="reasonForEquipment"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.reasonForEquipment" placeholder="Reason for equipment purchase *">
                        <!-- <el-option label="Reason for equipment purchase" value="" disabled></el-option> -->
                        <el-option
                          v-for="item in equipmentTypes"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="amount" required>
                      <el-input type="number" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="brokerSubmitForm.amount" placeholder="Loan amount *">
                        <template slot="prepend">$</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item prop="term">
                      <el-select v-model="brokerSubmitForm.term" placeholder="Desired loan term">
                        <el-option label="Desired loan term" value="Desired loan term" disabled></el-option>
                        <el-option
                          v-for="item in equipmentLoanTermS"
                          :key="item.value"
                          :label="item.text.concat(' months')"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      prop="wantDownPayment"
                      class="step-form__form-item--with-unit"
                      required
                    >
                      <el-select v-model="brokerSubmitForm.wantDownPayment" placeholder="Do you want to pay a down payment *">
                        <el-option label="Do you want to pay a down payment" value="" disabled></el-option>
                        <el-option
                          v-for="item in downPaymentOrNot"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Equipment description" class="margin-bottom-0" prop="equipmentDesc">
                  <el-input type="textarea" v-model="brokerSubmitForm.equipmentDesc" :rows=3></el-input>
                </el-form-item>

                <div v-if="frontApplyId != ''">
                  <el-row>
                      <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom:30px;">Documents</h3>
                  </el-row>
                  <div v-if="uploadedDocuments.length > 0">
                    <el-table :data="uploadedDocuments" align="left">
                      <el-table-column type='index' label="#" >
                        <template slot-scope="scope">
                          <span>{{scope.$index + 1}}</span>
                        </template>
                      </el-table-column>

                      <el-table-column prop="file_name" label="File Name"></el-table-column>

                      <el-table-column prop="file_category" label="File Category"></el-table-column>

                      <el-table-column label="Actions">
                        <template slot-scope="scope">
                          <el-button size="mini" type="primary" @click="reviewFile(scope.row.file_url)">Review</el-button>
                          <!-- <el-button size="mini" type="danger" @click="deleteFile(scope.row.fileId)">Delete</el-button> -->
                        </template>
                      </el-table-column>
                    </el-table>
                    <br>
                  </div>
                  <div class="review-section col-lg-12 row" style="text-align: left">
                    <div class="amcredit-text">Upload any documents related to you or your business. Files must be PDF, JPEG, PNG, DOC or XLS, 25mb max.</div>
                    <div class="remove-padding col-lg-12">
                      <multiple-uploads @ready="childVal => { uploadedFiles = childVal }" :key="fileUploadComponentKey"/>
                    </div>
                  </div>
                </div>

                <el-form-item class="margin-bottom-0" style="margin-top: 25px;">
                  <el-input type="textarea" placeholder="Notes" v-model="brokerSubmitForm.brokerNote" :rows=3></el-input>
                </el-form-item>

              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
          <div class="step-form__main pt-3">
            <!-- <el-row :gutter="0">
              <el-col :span="16">
                <el-form class="step-form__form">

                  <el-row>
                      <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px; margin-bottom: 20px;">Declaration</h3>
                  </el-row>

                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">
                  I hereby confirm that each Company Owner of the Company provided in this Application (i) is aware of the Company&#39;s request for financing; (ii) may be required to guaranty the requested financing; and (iii) have authorized American Credit, Inc and any assignee, lender, or funding service that may be used to obtain their respective business and consumer credit report and have authorized me to provide their consent (collectively theCredit Consent).
                  </p>

                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">
                  By clicking I agree below, I am authorized to, and hereby permit, American Credit, Inc and any assignee, lender, or funding service that may be used to obtain (i) a consumer credit report on each Company Owner for credit purposes & further authorize the release to American Credit, Inc and any assignee, lender, or funding service that may be used of all credit information it may request, including business & personal banking, mortgage, landlord, trade & lease information related to each of them; and (ii) confirm that each Company Owner of the company has provided the Credit Consent.
                  </p>
                  
                  <div style="text-align: left; margin-left: 5px;">
                    <el-radio-group v-model="declarationAgree" style="text-align: left;">
                      <el-row :gutter="10">
                        <el-radio label="agree">I agree</el-radio>
                      </el-row>
                      <el-row :gutter="10">>
                        <el-radio label="disagree">I disagree</el-radio>
                      </el-row>
                    </el-radio-group>
                  </div>
                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">I hereby confirm that by providing American Credit, Inc and any assignee, lender, or funding service that may be used with an email address or telephone number, including for a wireless device, I have obtained, and am authorized to provide, the necessary express consent from each Company Owner, and that by submitting this Application, I expressly consent on behalfof each Company Owner to communications including email, voice and text messages from, or on behalf of, American Credit, Inc and any assignee, lender, or funding service that may be used, regardless of their purpose, including but not limited to marketing or collection purposes. I understand and agree that: (i) these calls and messages may be subject to charges from an internet or wireless provider; (ii) this consent is not a condition of doing business with, or making a purchase of any goods/services from, American Credit, Inc and any assignee, lender, or funding service that may be used;and (iii) any Company Owner may unsubscribe or opt-out of any further telemarketing calls or marketing text messages at any time.</p>

                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">By clicking submit, you hereby agree the information you provided as well asthe confirmations set forth in this Application are true and accurate.</p>

                  <p style="color: #33475b; font-family: 'Open Sans', sans-serif;font-weight: 400;font-size: 14px;line-height: 24px; text-align: left;">Thank you for your business credit application. We will review it carefully andget back to you promptly.</p>

                </el-form>
              </el-col>
            </el-row> -->

            <!-- <div class="step-form__btn-container" v-if="frontApplyId == ''">
              <el-button
                :disabled="declarationAgree !== 'agree'"
                type="primary"
                :loading="isLoading"
                class="rounded-pill blue px-5"
                style="float: center;"
                @click="submitApplicationForm"
              >Submit</el-button>
            </div> -->
            <div class="step-form__btn-container">
              <el-button
                type="primary"
                :loading="isLoading"
                class="rounded-pill blue px-5"
                style="float: center;"
                @click="submitApplicationForm"
              >Update</el-button>
            </div>
          <br />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { Loading } from "element-ui";
import * as types from "../../vuex/types";
import _ from "lodash";
import api from "../../vuex/api/index";
import CommonConstants from "../../constant/common.js";
import MultipleUploads from './../applyLoan/MultipleUploads.vue'
import axios from 'axios';

// ä¼�ä¸šé‚£è¾¹å¦‚æžœç•Œé�¢å·®å¼‚å�˜å¤§ï¼Œåˆ™å»ºè®®åˆ†å‡ºåŽ»å�¦ä¸€ä¸ªç»„ä»¶
export default {
  components: {
    MultipleUploads
	},
  data() {
    const assignValidator = (type, trigger = "blur") =>
      Object.assign(
        {
          //        required: true,
          trigger
        },
        {
          validator: (rules, value, callback, source, options) => {
            this.$store.dispatch(type, {
              rules,
              value,
              callback,
              source,
              options
            });
          }
        }
      );
    return {
      fileUploadComponentKey: 0,
      uploadedFiles: null,
      pickerOptions1: {
        disabledDate(time) {
          let curDate = (new Date()).getTime();
          let I8Years = (365 * 18 + 5) * 24 * 3600 * 1000;
          let I00Years = (365 * 100 + 26) * 24 * 3600 * 1000;
          let I8YearsDate = curDate - I8Years;
          let I00YearsDate = curDate - I00Years;
          // return time.getTime() > I8YearsDate || time.getTime() < I00YearsDate;
          return time.getTime() < I00YearsDate;
        }
      },
      isLoading: false,
      isLoadingCode: false,
      isSubmitting: false,
      isEditable: "",
      screenHeight: document.body.clientHeight,
      isApplyFirst: true,
      frontApplyId: this.$route.params.frontApplyId || "",
      clientCustomerId: "",
      clientEmployerId: "",
      uploadedDocuments: [],
      industries: CommonConstants.industries,
      structures: CommonConstants.structures,
      equipmentLoanTermS: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "18", text: "18" },
        { value: "24", text: "24" },
        { value: "30", text: "30" },
        { value: "36", text: "36" },
        { value: "42", text: "42" },
        { value: "48", text: "48" },
        { value: "54", text: "54" },
        { value: "60", text: "60" },
        { value: "66", text: "66" },
        { value: "72", text: "72" }
      ],
      equipmentTypes: CommonConstants.equipmentTypes,
      stateS: CommonConstants.states,
      // titleData: [],
      // mastateS: [],
      status: CommonConstants.status,
      downPaymentOrNot: CommonConstants.downPaymentOrNot,
      titled: [
        {
          value: "Titled",
          text: "Titled"
        },
        {
          value: "Non-titled",
          text: "Non-titled"
        }
      ],
      showAddOwner: false,
      isEditable: 0,
      dateOfBirthStr: "",
      dateOfBirth2Str: "",
      dialogImageUrl: "",
      dialogImageUrl2: "",
      fileUrl1:"",
      fileUrl2:"",
      fileName1:"",
      fileName2:"",
      dialogVisible: false,
      dialogVisible2: false,
      declarationAgree: "",
      brokerSubmitForm: {
        businessName: "",
        tradeName: "",
        businessStreetAddress: "",
        businessStreetAddressLine2: "",
        businessCityName: "",
        businessState: "",
        businessZip: "",
        businessPhone: "",
        companyEmail: "",
        // fax: "",
        description: "",
        industry: "",
        structure: "",
        // dateEstablished: "",
        yearsInBusiness: "",
        revenue: "",
        url: "",
        tin: "",

        amount: "",
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        cellPhone: "",
        validCode: "",
        streetAddress: "",
        streetAddressLine2: "",
        cityName: "",
        title: "",
        jobTitle: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        dateOfBirth: "",
        homeOwnership: "",
        military: false,
        ssn: "",
        driverLicense: "",
        month: "",
        housingCost: "",
        businessOwnership: "",
        firstName2: "",
        middleName2: "",
        lastName2: "",
        email2: "",
        cellPhone2: "",
        streetAddress2: "",
        streetAddress2Line2: "",
        cityName2: "",
        title2: "",
        jobTitle2: "",
        zipCode2: "",
        state2: "",
        dateOfBirth2: "",
        homeOwnership2: "",
        month2: "",
        housingCost2: "",
        ssn2: "",
        status2: "",
        driverLicense2: "",
        businessOwnership2: "",

        vendorName: "",
        vendorPhone: "",
        vendorAddress: "",
        vendorCity: "",
        vendorState: "",
        vendorZipCode: "",
        vendorContactFirstName: "",
        vendorContactLastName: "",
        vendorContactEmail: "",
        equipmentDesc: "",
        equipmentAmount: "",
        equipmentStatus: "",
        term: "",
        wantDownPayment: null,
        equipmentTitle: "",
        equipmentType: "",
        reasonForEquipment: "",
        stateOfInc: ""
      },
      rules: {
        tin: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("EIN can not be empty"));
              }else if (_.trim(value).length != 10 ) {
                callback(new Error("TIN must be 9 digital"));
              } 
              else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      myInfo: types.GET_MY_INFO,
      userInfo: types.GET_USER,
      readDeclaration: types.GET_DECLARATION_IMAGE_SRC
    })
  },
  methods: {
    ...mapActions({
      updatePassword: types.UPDATE_PASSWORD,
      getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    ...mapMutations({
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE,
    }),

    // reviewFile(fileId) {
    //   return window.open('mingdao/mobile/crmCustomerAttachInfoController/getFileById.ht?fileId=' + fileId, "_blank");
    // },

    reviewFile(fileUrl) {
      return window.open(
        fileUrl,
        '_blank' // <- This is what makes it open in a new window.
      );
    },

    deleteFile(fileId) {
      api.deleteUploadedFile({
        token: this.userInfo.tokenId,
        id: fileId
      }).then((res) => {
        return this.getMgxyGetClientDetails();
      });
    },

    getMgxyGetPersonDetails() {
    },

    getData(val) {
      this.dateOfBirthStr = val;
    },
    getData2(val) {
      this.dateOfBirth2Str = val;
    },

    handleTinInput(value) {
      console.log(value)
      var newValue = value.replaceAll("-", "");
      if (newValue.length > 2) {
        this.brokerSubmitForm.tin = newValue.substr(0, 2) + "-" + newValue.substr(2);
      }
      console.log(this.brokerSubmitForm.tin)
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl2 = file.url;
      this.dialogVisible2 = true;
    }, 
    handleAvatarSuccess(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      // this.fileUrl1 = 'mingdao/mobile/crmCustomerAttachInfoController/getFileById.ht?fileId=' + res.result.fileId;
      //var uploaded = document.getElementById("uploaded");
      //uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      // this.bankStatement = res.result.fileId;
      // this.fileName1 = res.result.fileName;
      return this.getMgxyGetClientDetails();
    },
    // handleAvatarSuccess2(res, file) {
    //   Loading.service({ fullscreen: true, lock: true }).close();
    //   console.log(res.result);
    //   this.fileUrl2 = 'mingdao/mobile/crmCustomerAttachInfoController/getFileById.ht?fileId=' + res.result.fileId;
    //   // var uploaded = document.getElementById("uploaded2");
    //   // uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
    //   this.paymentStatement = res.result.fileId;
    //   this.fileName2 = res.result.fileName;
    // },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      return true;
    },
    openFullScreen() {
      Loading.service({ fullscreen: true, lock: true });
    },

    getAge(dateString) {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age > 18;
    },
    
    getMgxyGetClientDetails() {
      var _this = this;
      //console.warn(this.userInfo)
      api.mgxyGetPersonDetails({
        token: _this.userInfo.token,
        frontApply: _this.frontApplyId,
        customerId: _this.clientCustomerId,
      }).then((res) => {
        var _data = res.data;
        if (_data.code == 0) {
          console.log(_data);
          // _this.uploadedDocuments = _data.result.uploadedFileList;

          _this.brokerSubmitForm.jobTitle = _data.result.jobTitle || "";
          _this.brokerSubmitForm.firstName = _data.result.firstName;
          _this.brokerSubmitForm.middleName = _data.result.middleName || "";
          _this.brokerSubmitForm.lastName = _data.result.lastName;
          _this.brokerSubmitForm.email = _data.result.email;
          _this.brokerSubmitForm.cellPhone = _data.result.phone;
          // _this.brokerSubmitForm.dateOfBirth = _data.result.dateOfBirth ? new Date(_data.result.dateOfBirth.replace(/-/g, "\/")) : "";
          // if (_data.result.dataOfBirth && _data.result.dataOfBirth != '') {
          //   this.dateOfBirthDis = true;
          // }
          _this.brokerSubmitForm.ssn = _data.result.ssn;
          _this.brokerSubmitForm.streetAddress = _data.result.streetAddress;
          _this.brokerSubmitForm.streetAddressLine2 = _data.result.streetAddressLine2;
          _this.brokerSubmitForm.driverLicense = _data.result.driverLicense;
          // _this.brokerSubmitForm.housingCost = _data.result.housingCost;
          _this.brokerSubmitForm.state = _data.result.state;
          // _this.brokerSubmitForm.status = _data.result.status;
          _this.brokerSubmitForm.cityName = _data.result.cityName;
          _this.brokerSubmitForm.zipCode = _data.result.zipCode;
          // if(_data.result.month !== null && _data.result.month !== undefined && _data.result.month !== '') {
          //   _this.brokerSubmitForm.month = new Date(_data.result.month);
          // } 
          // _this.brokerSubmitForm.homeOwnership = _data.result.homeOwnership;
          _this.brokerSubmitForm.businessOwnership = _data.result.businessOwnership;
          
          _this.brokerSubmitForm.jobTitle2 = _data.result.jobTitle2 || "";
          _this.brokerSubmitForm.firstName2 = _data.result.firstName2 || "";
          _this.brokerSubmitForm.middleName2 = _data.result.middleName2 || "";
          _this.brokerSubmitForm.lastName2 = _data.result.lastName2 || "";
          _this.brokerSubmitForm.email2 = _data.result.email2 || "";
          _this.brokerSubmitForm.cellPhone2 = _data.result.phone2 || "";
          // _this.brokerSubmitForm.dateOfBirth2 = _data.result.dateOfBirth2 ? new Date(_data.result.dateOfBirth2.replace(/-/g, "\/")) : "";
          _this.brokerSubmitForm.ssn2 = _data.result.ssn2 || "";
          _this.brokerSubmitForm.streetAddress2 = _data.result.streetAddress2 || "";
          _this.brokerSubmitForm.streetAddress2Line2 = _data.result.streetAddress2Line2 || "";
          _this.brokerSubmitForm.driverLicense2 = _data.result.driverLicense2 || "";
          // _this.brokerSubmitForm.housingCost2 = _data.result.housingCost2;
          _this.brokerSubmitForm.state2 = _data.result.state2 || "";
          // _this.brokerSubmitForm.status2 = _data.result.status2;
          _this.brokerSubmitForm.cityName2 = _data.result.cityName2 || "";
          _this.brokerSubmitForm.zipCode2 = _data.result.zipCode2 || "";
          // if(_data.result.month2 !== null && _data.result.month2 !== undefined && _data.result.month2 !== '') {
          //   _this.brokerSubmitForm.month2 = new Date(_data.result.month2);
          // } 
          // _this.brokerSubmitForm.homeOwnership2 = _data.result.homeOwnership2;
          _this.brokerSubmitForm.businessOwnership2 = _data.result.businessOwnership2 || "";
          console.log(_this.brokerSubmitForm);
        }
      })
    },

    formatData(data) {
      var arr = [];
      for (var key in data) {
        var obj = {};
        obj.value = data[key];
        obj.text = key;
        arr.push(obj);
      }
      return arr;
    },
    formatDataForSort(data) {
      var arr = [];
      var arr2 = [];
      for (var key in data) {
        arr[arr.length] = data[key];
      }
      arr.sort();
      for (var k in arr) {
        for (key in data) {
          if (data[key] == arr[k]) {
            var obj = {};
            obj.value = data[key];
            obj.text = key;
            arr2.push(obj);
          }
        }
      }
      return arr2;
    },
    getMgxyDictionary() {
      var _this = this;
      api.mgxyDictionary().then(res => {
        _this.stateS = _this.formatData(res.data.result[0]);
        _this.titleData = _this.formatData(res.data.result[7]);
        _this.mastateS = _this.formatData(res.data.result[6]);
      });
    },

    brokerSubmitLoan() {
      var _this = this;
      var registerData = {
          firstName: _this.brokerSubmitForm.firstName,
          lastName: _this.brokerSubmitForm.lastName,
          middleName: _this.brokerSubmitForm.middleName,
          email: _this.brokerSubmitForm.email,
          brokerId: this.userInfo.crmCustomerId
      }
          
      api.brokerRegisterUser(registerData)
      .then(res => {
        this.isRegistering = false;
        if (Number(res.data.code) == 0) {

          var data = res.data.data;
          _this.clientCustomerId = data.crmCustomerId;
          
          api
            .mgxyBrokerApply({
              tokenId: _this.userInfo.token,
              clientCustomerId: _this.clientCustomerId,
              frontApplyProductId: 10000057823975,
              frontApplyMoney: _this.brokerSubmitForm.amount,
              frontApplyExpires: _this.brokerSubmitForm.term,
              frontApplyExpiresUnit: 2,
              frontInformationSources: '5'
            })
            .then(res => {
              console.log(res);
              var _data = res.data;
              if (_data.code == 0) {
                _this.frontApplyId = _data.result.frontApplyId;
                api.postForm("/mobile/item/loanItemFrontApply/mgxyUpdateApplyForFinish.ht",
                  {
                    tokenId: _this.userInfo.token,
                    frontApplyId: _this.frontApplyId
                  }
                ).then(res => {
                  _this.isLoading = false;
                  _this.saveBusinessOwner();
                });
              } else {
                this.setAlertMessage({
                  show: true,
                  content: _data.msg
                });
              }
            });
          return true;
        } else {
          if (res.data.result === "Failed to save, business owner email already exist") {
            alert(res.data.result);
          }
          return false;
        }
      });
    },
    submitApplicationForm() {
      var _this = this;
      this.$refs.brokerSubmitForm.validate(valid => {
        if (valid) {
          if(_this.frontApplyId === "") {
            _this.brokerSubmitLoan();
          } else {
            // this.openFullScreen();
            _this.saveUploadedFiles();
          }
        } else {
          this.$alert("Please input all required fields");
          return;
        }
      });
    },

    checkFileTypes(files) {
      var allTypesSelected = true;
      files.forEach(file => {
        if(!file.category || file.category == '') {
          allTypesSelected = false;
        }
      })
      return allTypesSelected;
    },

    saveUploadedFiles() {
      this.isLoading = true;
      if(this.uploadedFiles && this.uploadedFiles.length > 0) {
        if(!this.checkFileTypes(this.uploadedFiles)) {
          this.setAlertMessage({
            show: true,
            content: "Please select types for all uploaded documents first!"
          });
          return this.isLoading = false;
        }

        var filesToSave = {
          files: this.uploadedFiles,
          application_id: this.frontApplyId
        }
        axios.post("https://api.amcredit.com/apply/update", filesToSave)
          .then(res => {
            // this.setSuccessMessage({
            //   show: true,
            //   content: "Submission successful!"
            // });
            this.saveBusinessOwner();
          });
      } else {
        this.saveBusinessOwner();
      }
    },

    saveBusinessOwner() {

      var _this = this;

      // if (!this.getAge(this.dateOfBirthStr)) {
      //   this.$alert("Business owner must be more than 18 years old, please double check date of birth");
      //   return;
      // }
      var isValid = "";
      if (_this.isApplyFirst) {
        isValid = 2;
      } else {
        _this.SMSVerificationCode = "111111";
        isValid = 2;
      }

      var Month = new Array();
      Month[0] = "January";
      Month[1] = "February";
      Month[2] = "March";
      Month[3] = "April";
      Month[4] = "May";
      Month[5] = "June";
      Month[6] = "July";
      Month[7] = "August";
      Month[8] = "September";
      Month[9] = "October";
      Month[10] = "November";
      Month[11] = "December";

      var postData = {
        customerId: _this.clientCustomerId,
        tokenId: _this.userInfo.token,
        frontApplyId: _this.userInfo.crmCustomerId,
        lastName: _this.brokerSubmitForm.lastName,
        firstName: _this.brokerSubmitForm.firstName,
        middleName: _this.brokerSubmitForm.middleName,
        email: _this.brokerSubmitForm.email,
        phone: _this.brokerSubmitForm.cellPhone,
        validCode: _this.brokerSubmitForm.validCode,
        streetAddress: _this.brokerSubmitForm.streetAddress,
        streetAddressLine2: _this.brokerSubmitForm.streetAddressLine2,
        cityName: _this.brokerSubmitForm.cityName,
        title: _this.brokerSubmitForm.title || "",
        jobTitle: _this.brokerSubmitForm.jobTitle,
        state: _this.brokerSubmitForm.state,
        ssn: _this.brokerSubmitForm.ssn,
        driverLicense: _this.brokerSubmitForm.driverLicense,
        zipCode: _this.brokerSubmitForm.zipCode,
        // status: _this.brokerSubmitForm.status,
        // dateOfBirth: _this.dateOfBirthStr,
        isValid: 1,
        // homeOwnership: _this.brokerSubmitForm.homeOwnership,
        customer_area: _this.brokerSubmitForm.military ? "Military" : "",
        military: _this.brokerSubmitForm.military,
        // month: _this.brokerSubmitForm.month == "" ? "" : _this.brokerSubmitForm.month.toISOString(),
        // housingCost: _this.brokerSubmitForm.housingCost,
        businessOwnership: _this.brokerSubmitForm.businessOwnership,
        lastName2: _this.brokerSubmitForm.lastName2,
        firstName2: _this.brokerSubmitForm.firstName2,
        middleName2: _this.brokerSubmitForm.middleName2,
        email2: _this.brokerSubmitForm.email2,
        phone2: _this.brokerSubmitForm.cellPhone2,
        streetAddress2: _this.brokerSubmitForm.streetAddress2,
        streetAddress2Line2: _this.brokerSubmitForm.streetAddress2Line2,
        cityName2: _this.brokerSubmitForm.cityName2,
        jobTitle2: _this.brokerSubmitForm.jobTitle2,
        state2: _this.brokerSubmitForm.state2,
        ssn2: _this.brokerSubmitForm.ssn2,
        driverLicense2: _this.brokerSubmitForm.driverLicense2,
        zipCode2: _this.brokerSubmitForm.zipCode2,
        // status2: _this.brokerSubmitForm.status2,
        // dateOfBirth2: _this.dateOfBirth2Str,
        // homeOwnership2: _this.brokerSubmitForm.homeOwnership2,
        // month2: _this.brokerSubmitForm.month2 == "" ? "" : _this.brokerSubmitForm.month2.toISOString(),
        // housingCost2: _this.brokerSubmitForm.housingCost2,
        businessOwnership2: _this.brokerSubmitForm.businessOwnership2
      };

      console.log('postData', postData);

      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyBrokerUpdateApplyForPersonDetails.ht",
          postData 
        )
        .then(res => {
          console.log(res);
          var _data = res.data;
          if (_data.code == 0) {
            // this.setAlertMessage({
            //   show: true,
            //   content: "Success to save personal information"
            // });
            console.log("Success to save personal information");
            _this.submitBusinessInfo();
          } else {
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
        });
    },

    submitBusinessInfo() {
      var _this = this;
      api.postForm("/mobile/item/loanItemFrontApply/updateSBL01.ht", {
        tokenId: _this.userInfo.token,
        customerId: _this.clientCustomerId,
        frontApplyId: _this.frontApplyId,
        
        name: _this.brokerSubmitForm.businessName,
        tradeName: _this.brokerSubmitForm.tradeName,
        street: _this.brokerSubmitForm.businessStreetAddress,
        street2: _this.brokerSubmitForm.businessStreetAddressLine2,
        city: _this.brokerSubmitForm.businessCityName,
        state: _this.brokerSubmitForm.businessState,
        zipCode: _this.brokerSubmitForm.businessZip,
        phone: _this.brokerSubmitForm.businessPhone,
        tin: _this.brokerSubmitForm.tin,
        fax: _this.brokerSubmitForm.fax,
        industry: _this.brokerSubmitForm.industry,
        structure: _this.brokerSubmitForm.structure,
        // dateEstablished: typeof _this.brokerSubmitForm.dateEstablished === 'string' ? _this.brokerSubmitForm.dateEstablished : _this.brokerSubmitForm.dateEstablished.toISOString(),
        yearsInBusiness: _this.brokerSubmitForm.yearsInBusiness,
        revenue: _this.brokerSubmitForm.revenue,
        website: _this.brokerSubmitForm.url,
        businessDesc: _this.brokerSubmitForm.description,
        companyEmail: _this.brokerSubmitForm.companyEmail,
        stateOfIncorporation: _this.brokerSubmitForm.stateOfInc
      }).then(res => {
        //             alert(res.date.code);
        //             alert(res.date.msg);
        var _data = res.data;
        if (_data.code == 0) {
          console.log(res);
          // this.setAlertMessage({
          //   show: true,
          //   content: "Success to save business information"
          // });
          console.log("Success to save business information");
          _this.submitVendorForm();
        } else {
          this.setAlertMessage({
            show: true,
            content: _data.msg
          });
        }
      });
    },

    submitVendorForm() {
      var vendorData = {
        tokenId: this.userInfo.token,
        customerId: this.clientCustomerId,
        frontApplyId: this.frontApplyId,

        vendorName: this.brokerSubmitForm.vendorName,
        vendorPhone: this.brokerSubmitForm.vendorPhone,
        vendorAddress: this.brokerSubmitForm.vendorAddress,
        vendorCity: this.brokerSubmitForm.vendorCity,
        vendorState: this.brokerSubmitForm.vendorState,
        vendorZipCode: this.brokerSubmitForm.vendorZipCode,
        equipmentAmount: this.brokerSubmitForm.equipmentAmount,
        vendorContactFirstName: this.brokerSubmitForm.vendorContactFirstName,
        vendorContactLastName: this.brokerSubmitForm.vendorContactLastName,
        vendorContactEmail: this.brokerSubmitForm.vendorContactEmail,
        equipmentTitle: this.brokerSubmitForm.equipmentTitle,
        equipmentType: this.brokerSubmitForm.equipmentType,
        reasonForEquipment: this.brokerSubmitForm.reasonForEquipment,
        wantDownPayment: this.brokerSubmitForm.wantDownPayment,
        brokerNote: this.brokerSubmitForm.brokerNote,
        equipmentStatus: this.brokerSubmitForm.equipmentStatus,
        equipmentDesc: this.brokerSubmitForm.equipmentDesc,
        bankStatement: this.bankStatement || "",
        paymentStatement: this.paymentStatement || ""
      }
      // if(this.brokerSubmitForm.equipmentAmount) {
      //   vendorData.equipmentAmount = this.brokerSubmitForm.equipmentAmount;
      // }

      api.postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", vendorData)
        .then(res => {
          console.log(res);
          console.log("Success to save vendor information");
          // update amount and term
          api.mgxyBrokerApply({
            tokenId: this.userInfo.token,
            // clientCustomerId: this.clientCustomerId,
            frontApplyId: this.frontApplyId,
            // frontApplyProductId: 10000057823975,
            frontApplyMoney: this.brokerSubmitForm.amount,
            frontApplyExpires: this.brokerSubmitForm.term
          }).then(res => {
            console.log(res)
            console.log("Success to save frontApply information");
            this.isLoading = false;
            this.setSuccessMessage({
              show: true,
              content: "Success to update application"
            });
            setTimeout(() => {
              this.$router.push("/brokerCenter");
            }, 3000)
            // window.location.reload(true);
            // window.scrollTo(0,0);
          })
        });
    },

    handleDialogClose(done) {
      if(this.declarationId == null || this.declarationId == 10000058500118) {
        this.showSignDeclarationWarning = true;
      } else {
        done();
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path.indexOf("register") !== -1) {
      next(false);
    } else {
      next();
    }
  },

  mounted() {
    console.log(this.frontApplyId);

    //get uploadedDocuments
    api.getApplicationFiles(this.frontApplyId).then(res => {
      res.data.files.forEach(file => {
        this.uploadedDocuments.push(file);
      })
      // this.fileUploadComponentKey += 1;
    })
    // this.getMgxyDictionary();
    this.getPersonalInitData({
      token: this.userInfo.token,
      customerId: this.userInfo.crmCustomerId
    }).then(res => {
      console.log(res);
      if (Number(res.data.code) === 0) {
        const data = res.data.result;
        console.log(data);
      }
    });
    if(this.frontApplyId) {
      api.getClientApply({
        token: this.userInfo.token,
        frontApplyId: this.frontApplyId
      }).then(res => {
        var _data = res.data;
        if (_data.code == 0) {
          console.log(_data);
          this.clientCustomerId = _data.result.clientCustomerId;
          this.clientEmployerId = _data.result.clientEmployerId;

          this.brokerSubmitForm.amount = _data.result.frontApplyMoney;
          if(_data.result.frontApplyExpires) this.brokerSubmitForm.term = _data.result.frontApplyExpires + ' months';
          this.getMgxyGetClientDetails();
          if(this.clientEmployerId) {
              console.log(this.clientCustomerId)
              api.getClientData({
                token: this.userInfo.token,
                customerId: this.clientCustomerId
              }).then(res => {
                console.log(res);
                if (Number(res.data.code) === 0) {
                  const data = res.data.result;
                  // if(data.employer.bankStatement && data.employer.bankStatement != "") {
                  //   this.bankStatement = data.employer.bankStatement;
                  //   this.fileUrl1 = 'mingdao/mobile/crmCustomerAttachInfoController/getFileById.ht?fileId=' + data.employer.bankStatement;
                  //   this.fileName1 = 'Click to preview uploaded document';
                  // }
                  // if(data.employer.paymentStatement && data.employer.paymentStatement != "") {
                  //   this.paymentStatement = data.employer.paymentStatement;
                  //   this.fileUrl2 = 'mingdao/mobile/crmCustomerAttachInfoController/getFileById.ht?fileId=' + data.employer.paymentStatement;
                  //   this.fileName2 = 'Click to preview uploaded document';
                  // }
                  if(data.employer.businessDesc) {
                    this.brokerSubmitForm.description = data.employer.businessDesc.replaceAll('&#x73;&#x63;&#x72;&#x69;&#x70;&#x74;', 'script');
                  }
                  this.brokerSubmitForm.tin = data.employer.tin;
                  // make sure all old tin formatted
                  if (this.brokerSubmitForm.tin == 9) {
                    var oldTin = this.brokerSubmitForm.tin;
                    this.brokerSubmitForm.tin = oldTin.substr(0, 2) + "-" + oldTin.substr(2);
                  }
                  this.brokerSubmitForm.businessCityName = data.employer.city;
                  this.brokerSubmitForm.businessName = data.employer.name;
                  this.brokerSubmitForm.tradeName = data.employer.tradeName || "";
                  this.brokerSubmitForm.fax = data.employer.fax;
                  this.brokerSubmitForm.url = data.employer.website || "";
                  this.brokerSubmitForm.companyEmail = data.employer.companyEmail;
                  this.brokerSubmitForm.stateOfInc = data.employer.stateOfIncorporation;
                  // this.brokerSubmitForm.businessDesc = data.employer.businessDesc.replaceAll('&#x73;&#x63;&#x72;&#x69;&#x70;&#x74;', 'script');
                  this.brokerSubmitForm.businessStreetAddress = data.employer.street;
                  this.brokerSubmitForm.businessStreetAddressLine2 = data.employer.street2;
                  this.brokerSubmitForm.businessPhone = data.employer.phone; 
                  this.brokerSubmitForm.revenue = data.employer.monthlyNetIncome; 
                  this.brokerSubmitForm.businessState = data.employer.state;
                  this.brokerSubmitForm.businessZip = data.employer.zipCode;
                  this.brokerSubmitForm.revenue = data.employer.revenue || "";
                  this.brokerSubmitForm.structure = data.employer.structure;
                  this.brokerSubmitForm.industry = data.employer.industry;
                  // this.brokerSubmitForm.dateEstablished = data.employer.dateEstablished ? new Date(data.employer.dateEstablished).toISOString().slice(0, 10) : '';                  
                  this.brokerSubmitForm.yearsInBusiness = data.employer.yearsInBusiness;
                  this.brokerSubmitForm.vendorName = data.employer.vendorName || "";
                  this.brokerSubmitForm.vendorPhone = data.employer.vendorPhone || "";
                  this.brokerSubmitForm.vendorAddress = data.employer.vendorAddress || "";
                  this.brokerSubmitForm.vendorCity = data.employer.vendorCity || "";
                  this.brokerSubmitForm.vendorState = data.employer.vendorState || "";
                  this.brokerSubmitForm.vendorZipCode = data.employer.vendorZipCode || "";
                  this.brokerSubmitForm.equipmentAmount = data.employer.equipmentAmount;
                  this.brokerSubmitForm.equipmentStatus = data.employer.equipmentStatus;
                  if(data.employer.equipmentDesc) {
                    this.brokerSubmitForm.equipmentDesc = data.employer.equipmentDesc.replaceAll('&#x73;&#x63;&#x72;&#x69;&#x70;&#x74;', 'script');
                  }
                  this.brokerSubmitForm.vendorContactFirstName = data.employer.vendorContactFirstName || "";
                  this.brokerSubmitForm.vendorContactLastName = data.employer.vendorContactLastName || "";
                  this.brokerSubmitForm.vendorContactEmail = data.employer.vendorContactEmail || "";
                  this.brokerSubmitForm.equipmentTitle = data.employer.equipmentTitle;
                  this.brokerSubmitForm.equipmentType = data.employer.equipmentType;
                  this.brokerSubmitForm.reasonForEquipment = data.employer.reasonForEquipment;
                  this.brokerSubmitForm.wantDownPayment = data.employer.wantDownPayment;
                  this.brokerSubmitForm.brokerNote = data.employer.brokerNote || "";
                }
              });
            }
          } else {
            this.setAlertMessage({
              show: true,
              content: _data.msg
            });
          }
      });
    }
  }
};
</script>

<style lang="scss">
.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}

.step-form__form .el-form-item {
    margin-bottom: 25px !important;
}

.step-form__form .el-form-item__error {
    padding-top: 5px !important;
}

.el-table__body-wrapper td .cell {
  padding-left: 18px !important;
}

.el-input-group__append, 
.el-input-group__prepend, 
.step-form__form .el-textarea .el-textarea__inner,
.step-form__form .el-input .el-input__inner {
  border-color: #606060 !important;
  border-radius: 0 !important;
}

</style>



// WEBPACK FOOTER //
// ApplicationDetail.vue?3af18cd7